import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        "&>h6":{
            fontSize: "1.5rem",
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
            </IconButton>
        ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
    return (
        <div>
            <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
                    Información para el usuario
                </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        Según artículo 5 del reglamento de la Ley Electoral y de Partidos Políticos, sobre el aviso efectuado posterior a la 
                        fecha de vencimiento para el cambio de residencia de un municipio a otro.
                    </Typography>
                    <br></br>
                    <Typography gutterBottom>
                        De conformidad al acuerdo 7-2022, el plazo para actualizar la residencia electoral de los guatemaltecos residentes 
                        en el extranjero, deberá realizarse con anticipación no menor de tres meses antes de la celebración de la primera 
                        elección de Presidente y Vicepresidente de la República.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={props.handleClose} color="primary">
                        ok, he entendido
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
